import { globalStores } from '@/editor/stores';
import ModelGroupEntity from '@/editor/entities/modelGroupEntity';

export class ModelGroupManager {
  private _list: ModelGroupEntity[] = [];

  getEntity(entityId: string) {
    return this._list.find((entity) => entity.id === entityId);
  }

  private deleteGroupEntity(index: number) {
    if (index >= this._list.length || index < 0) return;
    this._list[index].dispose();
    this._list.splice(index, 1);
  }

  private addGroupEntity(entity: ModelGroupEntity) {
    this._list.push(entity);
  }

  update() {
    const modelGroupDatas = globalStores.modelGroupStore.modelGroupDatas;
    for (const modelGroupData of modelGroupDatas) {
      this.updateModelGroup({ id: modelGroupData.id });
    }
  }

  updateModelGroup({ id }: { id: string }) {
    const data = globalStores.modelGroupStore.getModelGroupData(id);
    let groupEntity = this.getEntity(id);
    if (!data) {
      if (groupEntity) this.deleteGroupEntity(this._list.indexOf(groupEntity));
      return;
    }

    if (!groupEntity) {
      groupEntity = new ModelGroupEntity({ id: data.id });
      this.addGroupEntity(groupEntity);
    }

    groupEntity.update(data);
  }
}
